import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useRecommendedProductPatch = () => {
  const branchId = useBranchId();

  const { t } = useTranslation();

  const mutation = useMutation({
    mutationFn: ({ menuItemID, recommendedProductID }: any) => {
      return patch(
        `internal/secure/pos/v1/menus/menu-item/add/recommended/${branchId}/${menuItemID}/${recommendedProductID}`
      );
    },
    onSuccess: () => {
      toast.success(t("success.update"));
    },
  });

  return mutation;
};

export default useRecommendedProductPatch;
